import React from 'react';
import client from 'services/apollo-client';
import TopRightMenu from 'components/canvas/components/top-right-menu';
import CanvasLoader from 'components/canvas/components/canvas-loader';
import { SurfaceNodeModal } from 'routes/surface/components/surface-node-modals/style';
import { useQuery } from '@apollo/client';
import { useHistory } from 'react-router';
import { Container } from './style';
import { homeSurfaceQuery } from 'graphql/surface/queries/home-surface';

function HomeNik() {
  const history = useHistory();

  const modal = React.useRef<any>(null);

  const [isLoading, setLoading] = React.useState(false);

  const { data, loading, error } = useQuery<any>(homeSurfaceQuery, {
    client,
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    // Error will be handled in ErrorBoundary
    setLoading(true);
  }, [error]);

  const rootSurface = data?.homeSurface?.data;

  console.log('NICK RENDER ', rootSurface);
  React.useEffect(() => {
    console.log('NICK LOGIN ', rootSurface);
    if (rootSurface?.id) {
      history.push('/immo-ox/list/' + rootSurface.id);
    }
  }, [loading]);

  return (
    <>
      {(loading || isLoading) && <CanvasLoader />}
      <SurfaceNodeModal
        ref={modal}
        disableClose
        shouldCloseOnOverlayClick={false}
        onHide={() => {
          history.push('/immo-ox/list/' + rootSurface.id);
        }}
      />
      <Container>
        <TopRightMenu />
      </Container>
    </>
  );
}

export default HomeNik;
